/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Postal/view.blocks to change it.
import Addresses from './Addresses/index'
import Heading from './Heading/index'
import NewAddress from './NewAddress/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Postal({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/ContactInfo/Postal"
  
}) {
  return (<React.Fragment
>
<Heading
  viewPath={`${viewPath}/Heading`}
/>
<Addresses
  viewPath={`${viewPath}/Addresses`}
/>
<NewAddress
  viewPath={`${viewPath}/NewAddress`}
/>
{children}
</React.Fragment>)
}